<script setup lang="ts">
import { toTypedSchema } from "@vee-validate/yup";
import { useField, useForm } from "vee-validate";
import { useI18n } from "vue-i18n";
import * as yup from "yup";

import { LanguageEnum, ThemeEnum, useSettingsStore, type Language, type Theme } from "@/stores/settings";

import { convertEnumToOptions } from "@/utils/Utils";

import { storeToRefs } from "pinia";
import { onMounted } from "vue";

import { definePage } from "unplugin-vue-router/runtime";

definePage({
  meta: {
    title: "Settings",
  },
});

const { t } = useI18n();

const settingsStore = useSettingsStore();
const settings = storeToRefs(settingsStore);

const validationSchema = yup.object({
  theme: yup.string<Theme>().required(),
  language: yup.string<Language>().required(),
});

const { handleSubmit, setFieldValue } = useForm({
  validationSchema: toTypedSchema(validationSchema),
});

const saveSettings = handleSubmit(values => {
  settings.theme.value = values.theme;
  settings.language.value = values.language;
});

const theme = useField("theme", validationSchema);
const language = useField("language", validationSchema);

onMounted(() => {
  setFieldValue("theme", settings.theme.value);
  setFieldValue("language", settings.language.value);
});
</script>

<template>
  <v-card class="ma-3">
    <v-form @submit.prevent="saveSettings">
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="6">
              <v-select
                v-model="theme.value.value"
                :label="t('settings.theme')"
                :items="convertEnumToOptions(ThemeEnum)"
                hide-details="auto"
              />
            </v-col>
            <v-col cols="6">
              <v-select
                v-model="language.value.value"
                :label="t('settings.language')"
                :items="convertEnumToOptions(LanguageEnum)"
                hide-details="auto"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-container>
          <v-row>
            <v-spacer />
            <v-btn
              color="primary"
              type="submit"
            >
              {{ t("settings.save") }}
            </v-btn>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-form>
  </v-card>
</template>
